export default __webpack_public_path__ + "static/media/logo.75f367b8.png";